import React from 'react';
let content;
export default props => (
  <section ref={e => content = e} className='content'>{props.children}</section>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/content/Content.jsx